import PropTypes from 'prop-types';
import React from 'react';

import { AttributionText, StyledAttribution } from './styles';

export const Attribution = ({
  className = null,
  maxWidth = null,
  children,
}) => {
  if (!children) return null;

  return (
    <StyledAttribution
      className={className}
      $maxWidth={maxWidth}
    >
      <AttributionText>
        {children}
      </AttributionText>
    </StyledAttribution>
  );
};

Attribution.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.number,
};
